import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=bca05482&scoped=true&"
import script from "./ServerDown.vue?vue&type=script&lang=js&"
export * from "./ServerDown.vue?vue&type=script&lang=js&"
import style0 from "./ServerDown.vue?vue&type=style&index=0&id=bca05482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca05482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca05482')) {
      api.createRecord('bca05482', component.options)
    } else {
      api.reload('bca05482', component.options)
    }
    module.hot.accept("./ServerDown.vue?vue&type=template&id=bca05482&scoped=true&", function () {
      api.rerender('bca05482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServerDown.vue"
export default component.exports